import { Tab } from '@headlessui/react';

import ClientNavigation from 'components/ClientNavigation';
import PageContent from 'components/PageContent';
import { useAssessmentStore } from 'hooks/useStore';

import ClientSurveys from './components/ClientSurveys';

export default function Surveys() {
  const clients = useAssessmentStore((state) => state.assessment.clients || []);

  return (
    <PageContent title="Ankiety">
      <div>
        <ClientNavigation clients={clients}>
          {clients.map((client) => (
            <Tab.Panel key={client.aclientId}>
              <ClientSurveys client={client} />
            </Tab.Panel>
          ))}
        </ClientNavigation>
      </div>
    </PageContent>
  );
}
